import { InjectionToken } from '@angular/core';
import type { BreadcrumbService } from './breadcrumb.service';

/**
 * Runtime handle on BreadcrumbService for base classes whose subclasses the service's own import
 * graph reaches (GeneralFormEditorComponent: breadcrumb -> object creator -> editor dialogs -> the
 * editor subclasses). Same rule and pattern as object-editor.token.ts.
 * Provided in app.config.ts with `useExisting: BreadcrumbService`.
 */
export const BREADCRUMB_SERVICE = new InjectionToken<BreadcrumbService>(
  'BreadcrumbService',
);
